function updateInsurance(cart) {

    console.log('update insurance price');
    console.log(cart);
    console.log(cart.items);

    

    $('.sm--cart-disable').addClass('sm--loading');

    var insurance_percentage = 0.15;

    var hair_price = 0;
    var insurance_id = 0;
    var insurance = {};
    if(cart.items) {

        // Triggered when changing the quantity and we have the whole cart
        $.each(cart.items, function(index, item) {

            if(item.product_type == 'hair') {
                hair_price += (item.quantity * item.price);
            }

            if(item.product_type == 'insurance') {
                insurance_id = item.product_id;
                insurance = item;
            }

        });

    } else {

        // Triggered when adding a new product and we have only the product
        console.log('adding new product to the cart');
        console.log(CartJS.cart);
        $.each(CartJS.cart.items, function(index, item) {

            if(item.product_type == 'hair') {
                hair_price += (item.quantity * item.price);
            }

            if(item.product_type == 'insurance') {
                insurance_id = item.product_id;
                insurance = item;
            }

        });

        if(cart.product_type == 'hair') {
            console.log('also here');
            console.log(cart);
            hair_price += cart.price;
        }

    }

    if(hair_price == 0 || insurance_id == 0) {
        $('.sm--cart-disable').removeClass('sm--loading');
        console.log('no insurance');
        return;
    }

    console.log(parseInt(hair_price * insurance_percentage));
    console.log(insurance.final_price);

    if(parseInt(hair_price * insurance_percentage) == insurance.final_price) {
        $('.sm--cart-disable').removeClass('sm--loading');
        console.log('do nothing');
        return;
    }

    var insurance_price = (hair_price * insurance_percentage) / 100;

    insurance_price = insurance_price.toString();
    insurance_price = insurance_price.slice(0, (insurance_price.indexOf("."))+3);

    $.ajax({
        type: 'POST',
        url: 'http://insurance.startupmasters.eu/api/edit-price',
        data: 'price=' + insurance_price + '&product_id=' + insurance_id,
        dataType: 'json',
        success: function(response) {

            CartJS.addItem(response.variants[0].id, 1, {}, {
                "success": function(data, textStatus, jqXHR) {
                    $('body').trigger('added.ajaxProduct');
                    $('.sm--cart-disable').removeClass('sm--loading');
                },
                "error": function(data, textStatus, jqXHR) {
                    $('.sm--cart-disable').removeClass('sm--loading');
                }
            });
        },
        error: function(XMLHttpRequest, textStatus) {
            $('.sm--cart-disable').removeClass('sm--loading');
        }
    });

}

function bindCartWaveSignature() {

    var $checkbox = $('#WaveSignature');
    var $order_note = $('#CartSpecialInstructions');

    $checkbox.on('change', function () {

        if(this.checked) {
            // Set a cookie
            setCookie('wave_signature', 'yes', 365);
            localStorage.setItem('wave_signature', 'yes');
            $order_note.text('I want to wave the delivery signature of my order.');
        } else {
            setCookie('wave_signature', 'no', 365);
            localStorage.setItem('wave_signature', 'no');
            $order_note.text('');
        }

    });

}

function bindRegularCartWaveSignature() {

    var $checkbox = jQuery('#WaveRegularSignature');
    var $order_note = jQuery('#CartRegularSpecialInstructions');

    $checkbox.on('change', function () {

        if(this.checked) {
            // Set a cookie
            setCookie('wave_signature', 'yes', 365);
            localStorage.setItem('wave_signature', 'yes');
            $order_note.text('I want to wave the delivery signature of my order.');
        } else {
            setCookie('wave_signature', 'no', 365);
            localStorage.setItem('wave_signature', 'no');
            $order_note.text('');
        }

    });

}

function bindCartInsurance() {

    // var $checkbox = $('#HairInsurance');

    $('body').on('change', '#HairInsurance', function () {

        if(this.checked) {

            console.log('add product');

            $('.sm--cart-disable').addClass('sm--loading');

            theme.cart.getCart().then(function(cart) {

                var insurance_percentage = 0.15;

                var hair_price = 0;
                $.each(cart.items, function(index, item) {

                    if(item.product_type == 'hair') {
                        hair_price += (item.quantity * item.price);
                    }

                });

                var insurance_price = (hair_price * insurance_percentage) / 100;

                insurance_price = insurance_price.toString();
                insurance_price = insurance_price.slice(0, (insurance_price.indexOf("."))+3);

                $.ajax({
                    type: 'POST',
                    url: 'http://insurance.startupmasters.eu/api/add-product',
                    data: 'price=' + insurance_price,
                    dataType: 'json',
                    success: function(response) {

                        CartJS.addItem(response.variants[0].id, 1, {}, {
                            "success": function(data, textStatus, jqXHR) {
                                $('body').trigger('added.ajaxProduct');
                                $('.sm--cart-disable').removeClass('sm--loading');
                            },
                            "error": function(data, textStatus, jqXHR) {
                                $('.sm--cart-disable').removeClass('sm--loading');
                            }
                        });

                    },
                    error: function(XMLHttpRequest, textStatus) {
                        $('.sm--cart-disable').removeClass('sm--loading');
                    }
                });

            });

        } else {

            $('.sm--cart-disable').addClass('sm--loading');

            // Get the insurance product
            var insurance_id = 0;
            var product_id = 0;
            $.each(CartJS.cart.items, function(index, item) {

                if(item.product_type == 'insurance') {
                    insurance_id = item.variant_id;
                    product_id = item.product_id;
                }

            });

            CartJS.updateItemById(insurance_id, 0, {}, {
                "success": function(data, textStatus, jqXHR) {
                    $('body').trigger('added.ajaxProduct');
                    $('.sm--cart-disable').removeClass('sm--loading');
                },
                "error": function(data, textStatus, jqXHR) {
                    $('.sm--cart-disable').removeClass('sm--loading');
                }
            });

            $.ajax({
                type: 'POST',
                url: 'http://insurance.startupmasters.eu/api/delete-product',
                data: 'product_id=' + product_id,
                dataType: 'json',
                success: function(response) {
                },
                error: function(XMLHttpRequest, textStatus) {
                }
            });

            console.log('remove product');

        }

    });

}

$(window).on('load', function() {

    $('.single-item').slick({
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('iframe[src*="https://www.youtube.com/embed/"]').addClass("youtube-iframe");

    $(".slick-arrow, .slick-dots li").on('click', function() {

        $('iframe[id^="slider-video"]').each( function() {
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        })

    });

    // Bind the wave signature checkbox in the cart
    bindCartWaveSignature();

    // Bind the wave signature checkbox in the regular cart
    bindRegularCartWaveSignature();

    // Bind the insurance checkbox in the cart
    bindCartInsurance();

    // Make an additional check 2 seconds later if the user had clicked the wave signature BEFORE the page load
    // setTimeout(() => {
    //
    //     var $checkbox = $('#WaveSignature');
    //     var $order_note = $('#CartSpecialInstructions');
    //
    //     if($checkbox.is(":checked")) {
    //         setCookie('wave_signature', 'yes', 365);
    //         $order_note.text('I want to wave the delivery signature of my order.');
    //     } else {
    //         setCookie('wave_signature', 'no', 365);
    //         $order_note.text('');
    //     }
    //
    // }, 2000);

    // Color swatch names
    updateColorName();

});

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

function updateColorName () {

    var $colorNameContainer = jQuery('.sm--product-current-color-wrapper .sm--variant-color');

    jQuery('.webyzeSwatches').on('click', '.swatchColor', function() {

        var $el = jQuery(this);

        var text = $el.data('name');
        if(text === 'HL-A - Cola') {
            text += '<br> Coarse texture'
            jQuery('.sm--african-explanation').show();
        } else {
            jQuery('.sm--african-explanation').hide();
        }

        $colorNameContainer.html(text);

    });

}